import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionTag } from "./ui/SectionTag";
import { PRODUCTS } from "../constants";
import { Button } from "./ui/Button";

interface ProductSectionProps {
  onProductsClick?: () => void;
  onLearnMoreClick?: (productId: string) => void;
}

export const ProductSection: React.FC<ProductSectionProps> = ({
  onProductsClick,
}) => {

  return (
    <section className="bg-white px-2 lg:px-12 py-16 lg:py-24" id="products">
      <div className="mx-auto w-[90%] lg:w-[70%]">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start mb-12 lg:mb-16 gap-6">
          <div className="flex flex-col items-center lg:items-start">
            <SectionTag className="font-raleway">PRODUCT</SectionTag>
            <h2
              className="text-2xl md:text-3xl lg:text-heading-large font-bold bg-gradient-to-r
         from-[#e20016] from-[0%]
         via-[#712f59] via-[40%]
         to-[#005d9c] to-[100%] bg-clip-text text-transparent font-open-sans-hebrew text-center lg:text-left"
            >
              Trusted Plywood Choices Built For Every Interior Requirement
            </h2>
          </div>
          <div className="max-w-xs mt-2 flex flex-col items-center lg:items-start">
            <p className="text-gray-500 text-body mb-6 text-center lg:text-left font-raleway">
              High-quality plywood engineered for durability, stability, and
              flawless finishes across all modern interior applications.
            </p>
            <Button variant="red" onClick={onProductsClick}>
              <span className="font-raleway">Explore Croma Ply</span>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {PRODUCTS.map((product) => (
            <Link
              key={product.id}
              to={`/products/${product.id}`}
              className="flex flex-col bg-[#FAFAFA] rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="aspect-[4/3] w-full flex-shrink-0 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col flex-1 py-5 px-2 lg:p-6">
                <h3
                  className="text-xl font-normal bg-gradient-to-r from-[#e20016] from-[0%] via-[#712f59] via-[40%] to-[#005d9c] to-[100%] bg-clip-text text-transparent font-raleway mb-3"
                >
                  {product.name}
                </h3>
                <p className="text-gray-500 text-body flex-1 line-clamp-3 mb-4 font-raleway">
                  {product.description}
                </p>
                <span className="inline-flex items-center justify-between gap-2 w-[50%] md:w-auto min-w-[120px] px-6 py-2.5 rounded-lg text-sm font-medium text-white bg-[#E30026] hover:bg-[#c40022] transition-colors font-raleway">
                  Explore
                  <ArrowRight className="w-4 h-4 flex-shrink-0" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
